module.exports = __webpack_public_path__ + "img/filter.2d36f863.png";